import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaBars, FaTimes, FaPhone, FaMapMarkerAlt } from "react-icons/fa";
import { auth, db } from "../firebase"; // Import db
import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore"; // Import Firestore functions
import "../App.css";

// Updated logo import
import logo from "../assets/cremlora llc logo grey.jpg"; 

// Inline styles
const navStyles = {
  topBar: {
    background: "linear-gradient(110deg, #051337 0%, #1b2e4b 40%, #5d6d7e 50%, #1b2e4b 60%, #051337 100%)",
    color: "white",
    padding: "10px 0",
    fontSize: "0.9rem",
    borderBottom: "1px solid rgba(255,255,255,0.1)",
  },
  navContainer: {
    background: "#d8d8d9ff",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    position: "sticky",
    top: 0,
    zIndex: 1000,
  },
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 20px",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  logo: { display: "flex", alignItems: "center" },
  menu: { display: "flex", gap: "25px", alignItems: "center" },
  mobileMenu: {
    position: "absolute",
    top: "100%",
    left: 0,
    width: "100%",
    background: "white",
    flexDirection: "column",
    padding: "20px",
    boxShadow: "0 5px 5px rgba(0,0,0,0.1)",
  },
  logoutBtn: {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: "1rem",
    fontFamily: "inherit",
    color: "inherit", 
    padding: 0,
  }
};

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false); // New state for Admin check
  const navigate = useNavigate();

  // Watch for screen resizing
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Check Login Status and Role
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      
      if (currentUser) {
        try {
          // Check if the user is an admin
          const userDoc = await getDoc(doc(db, "users", currentUser.uid));
          if (userDoc.exists() && userDoc.data().role === 'admin') {
            setIsAdmin(true);
          } else {
            setIsAdmin(false);
          }
        } catch (error) {
          console.error("Error checking admin status:", error);
          setIsAdmin(false);
        }
      } else {
        setIsAdmin(false);
      }
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setIsOpen(false); 
      navigate("/"); 
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <>
      {/* Top Contact Bar */}
      <div style={navStyles.topBar}>
        <div
          className="container"
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "0 20px",
          }}
        >
          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <FaMapMarkerAlt /> 2785 terrace grove drive Conroe, TX 77304, USA
          </span>

          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <FaPhone /> (850) 736-4448 | Mon-Sat 9am-8pm
          </span>
        </div>
      </div>

      {/* Main Navbar */}
      <nav style={navStyles.navContainer}>
        <div style={navStyles.wrapper}>
          {/* Logo */}
          <Link to="/" style={navStyles.logo}>
            <img
              src={logo}
              alt="Cremlora LLC"
              style={{ height: "130px", width: "auto", objectFit: "contain" }}
            />
          </Link>

          {/* Desktop Menu */}
          {!isMobile && (
            <div className="navbar-links" style={navStyles.menu}>
              <Link to="/">Home</Link>
              {/* Changed Inventory to Dealership */}
              <Link to="/inventory">Dealership</Link> 
              <Link to="/about">About Us</Link>
              <Link to="/contact">Contact</Link>
              
              {user ? (
                <>
                  {/* Only show Dashboard if Admin */}
                  {isAdmin && <Link to="/admin">Dashboard</Link>}
                  
                  <button onClick={handleLogout} style={navStyles.logoutBtn}>
                    Logout
                  </button>
                </>
              ) : (
                <Link to="/login">Login</Link>
              )}

              {/* NEW BLINKING BUTTON */}
              <Link to="/general-goods" className="btn-blink">
                General Goods
              </Link>
            </div>
          )}

          {/* Mobile Icon */}
          {isMobile && (
            <div
              className="mobile-icon"
              onClick={toggleMenu}
              style={{ cursor: "pointer" }}
            >
              {isOpen ? (
                <FaTimes size={26} color="var(--primary-dark)" />
              ) : (
                <FaBars size={26} color="var(--primary-dark)" />
              )}
            </div>
          )}
        </div>

        {/* Mobile Dropdown */}
        {isOpen && isMobile && (
          <div style={navStyles.mobileMenu}>
            <Link
              to="/"
              onClick={toggleMenu}
              style={{ display: "block", padding: "10px 0", borderBottom: "1px solid #eee" }}
            >
              Home
            </Link>
            <Link
              to="/inventory"
              onClick={toggleMenu}
              style={{ display: "block", padding: "10px 0", borderBottom: "1px solid #eee" }}
            >
              Dealership
            </Link>
            {/* Mobile General Goods Link */}
             <Link
              to="/general-goods"
              onClick={toggleMenu}
              style={{ display: "block", padding: "10px 0", borderBottom: "1px solid #eee", color: 'red', fontWeight: 'bold' }}
            >
              General Goods
            </Link>

            <Link
              to="/about"
              onClick={toggleMenu}
              style={{ display: "block", padding: "10px 0", borderBottom: "1px solid #eee" }}
            >
              About Us
            </Link>
            <Link
              to="/contact"
              onClick={toggleMenu}
              style={{ display: "block", padding: "10px 0", borderBottom: "1px solid #eee" }}
            >
              Contact
            </Link>
            
            {user ? (
              <>
                 {/* Only show Dashboard if Admin */}
                 {isAdmin && (
                   <Link
                    to="/admin"
                    onClick={toggleMenu}
                    style={{ display: "block", padding: "10px 0", borderBottom: "1px solid #eee" }}
                  >
                    Dashboard
                  </Link>
                 )}
                <div 
                  onClick={handleLogout}
                  style={{ display: "block", padding: "10px 0", cursor: "pointer", color: "red" }}
                >
                  Logout
                </div>
              </>
            ) : (
              <Link
                to="/login"
                onClick={toggleMenu}
                style={{ display: "block", padding: "10px 0" }}
              >
                Login
              </Link>
            )}
          </div>
        )}
      </nav>
    </>
  );
};

export default Navbar;